import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    EditSavedSearchBanner,
    isShowEditSavedSearchBanner
} from '@zoopla/listing-search/banners/edit-saved-search';
import { useGetMapViewUrl } from '@zoopla/listing-search/use-map-view-url';
import { totalResultsTextSelector } from '@zoopla/redux-reducer-search-results';
import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    searchResultsHeaderWrapperStyle,
    searchResultsHeadingStyle,
    searchResultsTotalTextStyle,
    sectionThatAppearsWhenNoSideBarStyle,
    styledDividerStyle,
    styledFooterCellStyle,
    styledFooterStyle
} from './index.styles.css';
import { MapIcon } from './MapIcon';

export type SearchResultsHeaderProps = {
    pageTitle: string;
    isEditSavedSearchBannerVisible: boolean;
    userAlertId: string | null;
    previousSavedSearchUri: string | null;
    savedSearchAndAlertsUri: string | undefined;
    isLoggedIn: boolean | null;
    sortOrderDropdown: React.ReactElement;
    outcode?: string;
};

export const SearchResultsHeader: FC<
    React.PropsWithChildren<SearchResultsHeaderProps>
> = ({
    pageTitle,
    isEditSavedSearchBannerVisible,
    userAlertId,
    previousSavedSearchUri,
    savedSearchAndAlertsUri,
    isLoggedIn,
    sortOrderDropdown
}) => {
    const totalResultsText = useSelector(totalResultsTextSelector);

    const [showEditSavedSearchBanner, setShowEditSavedSearchBanner] =
        useState(false);

    useEffect(() => {
        if (!isEditSavedSearchBannerVisible) {
            setShowEditSavedSearchBanner(false);
        } else if (isLoggedIn) {
            const showEditSavedSearch = isShowEditSavedSearchBanner(
                userAlertId,
                previousSavedSearchUri,
                savedSearchAndAlertsUri
            );

            setShowEditSavedSearchBanner(!!showEditSavedSearch);
        }
    }, [
        isLoggedIn,
        isEditSavedSearchBannerVisible,
        userAlertId,
        previousSavedSearchUri,
        savedSearchAndAlertsUri
    ]);

    const mapIconLinkGenericParams = useGetMapViewUrl();

    return (
        <div
            className={searchResultsHeaderWrapperStyle}
            data-testid="search-results-header-control"
        >
            {showEditSavedSearchBanner ? (
                <div
                    className={sectionThatAppearsWhenNoSideBarStyle}
                    data-testid="search-results-header_edit-saved-search-cta"
                >
                    <EditSavedSearchBanner />
                </div>
            ) : null}

            <h1
                className={`${searchResultsHeadingStyle} ${fontGroups.plate}`}
                data-testid={`results-title`}
            >
                {pageTitle}
            </h1>

            <div className={styledFooterStyle}>
                <div className={styledFooterCellStyle}>
                    <p
                        className={`${searchResultsTotalTextStyle} ${fontGroups.ladle}`}
                        data-testid="total-results"
                    >
                        {totalResultsText}
                    </p>
                    <div className={styledDividerStyle} />
                    <MapIcon href={mapIconLinkGenericParams} />
                </div>
                <div className={styledFooterCellStyle}>{sortOrderDropdown}</div>
            </div>
        </div>
    );
};
